import { ReactNode } from "react";

interface MinimalThemeProps {
  children: ReactNode;
  themeColor: string;
  headingColor: string;
  buttonColor: string;
}

export default function MinimalTheme({ children, themeColor, headingColor, buttonColor }: MinimalThemeProps) {
  return (
    <div className="minimal-theme" style={{ background: '#ffffff', minHeight: '100vh' }}>
      <style>{`
        .minimal-theme {
          --theme-color: ${themeColor};
          --heading-color: ${headingColor};
          --button-color: ${buttonColor};
          background: #ffffff !important;
        }
        
        /* Override page background */
        .minimal-theme > div {
          background: #ffffff !important;
        }
        
        /* Minimal hero section */
        .minimal-theme .bg-gradient-to-br,
        .minimal-theme [style*="background"] {
          background: linear-gradient(to bottom, #fafafa, #ffffff) !important;
          border-radius: 0 !important;
          box-shadow: none !important;
        }
        
        /* Minimal cards */
        .minimal-theme .bg-white {
          background: white !important;
          border: 2px solid #e5e7eb !important;
          border-radius: 0.5rem !important;
          box-shadow: none !important;
        }
        
        .minimal-theme .bg-white:hover {
          border-color: ${themeColor} !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
        }
        
        /* Remove shadows */
        .minimal-theme .shadow-xl,
        .minimal-theme .shadow-2xl,
        .minimal-theme .shadow-lg {
          box-shadow: none !important;
          border: 1px solid #e5e7eb !important;
        }
        
        /* Minimal buttons */
        .minimal-theme button,
        .minimal-theme .btn {
          background: transparent !important;
          color: ${buttonColor} !important;
          border: 2px solid ${buttonColor} !important;
          border-radius: 0.375rem !important;
          box-shadow: none !important;
        }
        
        .minimal-theme button:hover,
        .minimal-theme .btn:hover {
          background: ${buttonColor} !important;
          color: white !important;
        }
        
        /* Typography */
        .minimal-theme h1, 
        .minimal-theme h2, 
        .minimal-theme h3 {
          font-weight: 600 !important;
          letter-spacing: -0.02em !important;
        }
        
        .minimal-theme p {
          line-height: 1.8 !important;
          color: #6b7280 !important;
        }
      `}</style>
      {children}
    </div>
  );
}
